var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18 12.771C18 16.047 16.047 18 12.771 18H11.7C11.205 18 10.8 17.595 10.8 17.1V11.907C10.8 11.664 10.998 11.457 11.241 11.457L12.825 11.43C12.951 11.421 13.059 11.331 13.086 11.205L13.401 9.48601C13.428 9.32401 13.302 9.171 13.131 9.171L11.214 9.198C10.962 9.198 10.764 9.00001 10.755 8.75701L10.719 6.552C10.719 6.408 10.836 6.28201 10.989 6.28201L13.149 6.246C13.302 6.246 13.419 6.12901 13.419 5.97601L13.383 3.81599C13.383 3.66299 13.266 3.546 13.113 3.546L10.683 3.58201C9.189 3.60901 8.00101 4.833 8.02801 6.327L8.073 8.802C8.082 9.054 7.88401 9.25201 7.63201 9.26101L6.552 9.279C6.399 9.279 6.28201 9.39599 6.28201 9.54899L6.30901 11.259C6.30901 11.412 6.426 11.529 6.579 11.529L7.65901 11.511C7.91101 11.511 8.10899 11.709 8.11799 11.952L8.19899 17.082C8.20799 17.586 7.80299 18 7.29899 18H5.229C1.953 18 0 16.047 0 12.762V5.229C0 1.953 1.953 0 5.229 0H12.771C16.047 0 18 1.953 18 5.229V12.771Z",
    fill: "#111748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3eca663af463154deb34678dcc7c2930.svg";
export { ForwardRef as ReactComponent };